import { render, staticRenderFns } from "./NotionalAccountCard.vue?vue&type=template&id=bbc6ef14&scoped=true"
import script from "./NotionalAccountCard.vue?vue&type=script&lang=ts"
export * from "./NotionalAccountCard.vue?vue&type=script&lang=ts"
import style0 from "./NotionalAccountCard.vue?vue&type=style&index=0&id=bbc6ef14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc6ef14",
  null
  
)

export default component.exports